// Renderer dispatcher — mosaic for avatars, halftone for market/outcome surfaces.

import type { PatternState, Render2DContext, RenderFn } from '../types';
import { renderHalftone } from './halftone';
import { renderMosaic } from './mosaic';

export const renderPattern: RenderFn = (
  ctx: Render2DContext,
  w: number,
  h: number,
  state: PatternState,
) => {
  if (state.renderer === 'mosaic') {
    renderMosaic(ctx, w, h, state);
    return;
  }
  renderHalftone(ctx, w, h, state);
};

export { renderHalftone, renderMosaic };
